import { useMemo } from "react";
import { useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    selectContainer: {
      marginLeft: "2em",
    },
    chooseInputRoot: {
      color: "white",
    },
    chooseInputIcon: {
      color: "white",
    },
  }),
);

const useAppSelect = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(
    () => ({
      appSelect: {
        root: styles.chooseInputRoot,
        icon: styles.chooseInputIcon,
      },
    }),
    [styles],
  );
  const atomicStyles = useAtomicStyles();

  return {
    styles,
    classes,
    atomicStyles,
  };
};

export { useAppSelect as default };
